/* Similar to the component found in planner. */
class ProductCard extends HTMLElement {
  

	constructor() {
		
		super();

		this.item_ID = Number(this.dataset.item_id)
		this.item_Price = Number(this.dataset.item_price); 	     
		this.item_ComparePrice = Number(this.dataset.item_compareprice); 	     
		this.item_TotalQTY = Number(this.dataset.item_totalqty);
		this.item_Policy = this.dataset.item_policy;
		this.item_TotalPrice = Number(this.dataset.item_totalprice);

		this.btn_plus = this.querySelector('input.plusQty');
		this.btn_minus = this.querySelector('input.minusQty');

		this.label_itemTotalQTY = this.querySelector('.label-item-total-qty'); 
		this.label_itemPricePerItem = this.querySelector('.label-price-per-item');
		this.label_itemPriceTotal = this.querySelector('.label-item-price-total');

		this.variant_selects = this.querySelectorAll('.variant-select select');
		if(this.variant_selects.length !== 0) { this.listeners_variants() }

		this.listeners_quantity();
		
	}


	listeners_variants() {
		this.variant_selects.forEach(select => {
			this.update_card_data(select);
			select.addEventListener('change', ()=> {			
				this.update_card_data(select);
				this.control_check_minusBtn(select)
				this.control_check_plusBtn(select)
			})

		})
	}


	listeners_quantity() {

		this.btn_minus.addEventListener('click', ()=> { 
			this.qty_decrease();       
			this.control_check_minusBtn();
			this.labels_update();
		})
		
		this.btn_plus.addEventListener('click', ()=> {             
			this.qty_increase(); 
			this.control_check_plusBtn();
			this.labels_update();
		})

	}


	update_card_data(select) {	
		this.current_selectedOption = select.options[ select.selectedIndex ];
		this.item_Price = this.current_selectedOption.dataset.variant_price;		
		this.item_ComparePrice = this.current_selectedOption.dataset.variant_compare_price;		
		this.dataset.item_id = this.current_selectedOption.value;	
		this.dataset.item_price = this.current_selectedOption.dataset.variant_price;
		this.dataset.item_policy = this.current_selectedOption.dataset.variant_policy;
		this.dataset.item_totalprice = `${ (this.item_TotalQTY * this.item_Price) }`;
		this.dataset.item_totalcompareprice = `${ (this.item_TotalQTY * this.item_ComparePrice) }`;
		this.label_itemPricePerItem.textContent = `${this.current_selectedOption.dataset.variant_pricemoney}`;	
		this.setAttribute('data-item_variant_invqty', `${this.current_selectedOption.dataset.variant_invqty}`);
		this.querySelector('img').src = this.current_selectedOption.dataset.variant_img;
	}


	qty_increase() {
		this.item_TotalQTY = this.item_TotalQTY + 1;
		this.item_TotalPrice = this.item_TotalQTY * this.item_Price;
		this.item_TotalComparePrice = this.item_TotalQTY * this.item_ComparePrice;
		this.dataset.item_totalqty = `${this.item_TotalQTY}`;         
		this.dataset.item_totalprice = `${this.item_TotalPrice}`;
		this.dataset.item_totalcompareprice = `${this.item_TotalComparePrice}`;      
	}


	qty_decrease() {	
		this.item_TotalQTY = this.item_TotalQTY - 1;
		this.item_TotalPrice = this.item_TotalQTY * this.item_Price;
		this.item_TotalComparePrice = this.item_TotalQTY * this.item_ComparePrice;		
		this.dataset.item_totalqty = `${this.item_TotalQTY}`;         
		this.dataset.item_totalprice = `${ (this.item_TotalPrice) }`;
        this.dataset.item_totalcompareprice = `${this.item_TotalComparePrice}`;        
	}


	labels_update() {  
		this.label_itemTotalQTY.textContent = `${this.item_TotalQTY}`;
		if(this.label_itemPriceTotal) {
			this.label_itemPriceTotal.textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.item_TotalPrice / 100)}`; 
		}
	}


	control_check_minusBtn(select) {

		//console.log('- this.item_TotalQTY', this.item_TotalQTY)

		if(this.item_TotalQTY > 0){

			this.control_toggle('enable', this.btn_minus)
		
			if(this.variant_selects.length !== 0) {

				if(this.item_TotalQTY < Number(this.dataset.item_variant_invqty)){
					//console.log('<')				
					this.control_toggle('enable', this.btn_plus)
				} 
				
				if(this.item_TotalQTY == Number(this.dataset.item_variant_invqty)) {
					//console.log('==')				
					this.control_toggle('disable', this.btn_plus)
				} 
				
				if(this.item_TotalQTY > Number(this.dataset.item_variant_invqty)){
					//console.log('>')
					this.item_TotalQTY = Number(this.dataset.item_variant_invqty);
					this.dataset.item_totalqty = this.item_TotalQTY;					
					this.update_card_data(select)
					this.labels_update()
				}

			}

		} else {	
			this.control_toggle('disable', this.btn_minus)		
			this.control_toggle('enable', this.btn_plus)
		}
	}


	control_check_plusBtn() {

		//console.log('+ this.item_TotalQTY', this.item_TotalQTY)

		if(this.item_TotalQTY > 0) {

			this.control_toggle('enable', this.btn_minus);
			this.control_toggle('enable', this.btn_plus);

			if(this.item_Policy == 'deny') {

				if(this.variant_selects.length !== 0) {
					//console.log('a')
					this.item_TotalQTY < Number(this.dataset.item_variant_invqty) ? 
						this.control_toggle('enable', this.btn_plus) : 
						this.control_toggle('disable', this.btn_plus);
				} else {
					//console.log('b')
					this.item_TotalQTY < Number(this.dataset.item_product_invqty) ? 
						this.control_toggle('enable', this.btn_plus) : 
						this.control_toggle('disable', this.btn_plus);
				}

			} 

		} else {			
			this.control_toggle('disable', this.btn_minus)
			this.control_toggle('enable', this.btn_plus)
		}

	}


	control_toggle(state, element) {         
		state == 'disable' ? element.disabled = true : element.disabled = false;
	}

  
}
customElements.define('product-card', ProductCard)



/* 
	Modified version of the planner ExtrasManager.
	Works without the <collection-toggler> element.
	Otherwise the incorporates the same functionality more or less.
*/
class ExtrasManager extends HTMLElement {


	constructor() {
		
		super();

		this.items = this.querySelectorAll('product-card'); 
		this.total_extras = this.dataset.total_extras;
		this.total_extras_price = this.dataset.total_extras_price;
        this.total_extras_compare_price = this.dataset.total_extras_compare_price;
		this.manager_details = this.querySelector('.manager-details');
		this.atc_btn = this.querySelector('multiitem-atc button');

		this.totalQTY = 0;
		this.totalPrice = 0;
		this.totalComparePrice = 0;

		this.add_mutation_observer();
		this.calculate_bulk_totals();
		this.update_manager();
		//this.update_labels_itemsPerCollection();

	}
	

	add_mutation_observer() {
		let targetNodes = document.querySelectorAll('product-card');          
		let options = { attributes: true };         
		let callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				if (mutation.type === 'attributes') {
					if(mutation.attributeName === "data-item_totalprice") {
						//console.log(mutation.attributeName)
						this.calculate_bulk_totals();
						//this.update_labels_itemsPerCollection();
					}
			                
				}              
			}
		};

		let extrasMutationObserver = new MutationObserver(callback);
		targetNodes.forEach((targetNode) => {
			extrasMutationObserver.observe(targetNode, options);
		})

	}


	calculate_bulk_totals() {
		this.totalQTY = 0;
		this.totalPrice = 0;
        this.totalComparePrice = 0;
		this.items.forEach((item) => {
			this.totalQTY = this.totalQTY + Number(item.dataset.item_totalqty);
			this.setAttribute('data-total_extras', `${this.totalQTY}`);
			this.totalPrice = this.totalPrice + Number(item.dataset.item_totalprice); 
			this.totalComparePrice = this.totalComparePrice + Number(item.dataset.item_totalcompareprice); 
			this.setAttribute('data-total_extras_price', `${this.totalPrice}`); 				
			this.setAttribute('data-total_extras_compare_price', `${this.totalComparePrice}`); 				
		});
		this.totalQTY > 0 ? this.dataset.hasextras = 'true' : this.dataset.hasextras = 'false';
		this.update_manager();
	}


	update_manager() {

		if(this.manager_details) { 
			this.querySelector('.label-items-total-qty').textContent = `${this.totalQTY}`
            this.totalComparePrice == this.totalPrice ? this.querySelector('.label-items-total-compare-price').style.display = "none" : this.querySelector('.label-items-total-compare-price').style.display = "inline-block";
			this.querySelector('.label-items-total-compare-price').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.totalComparePrice / 100)}`;
			this.querySelector('.label-items-total-price').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.totalPrice / 100)}`;
		}

		if(this.atc_btn) { 
			//console.log(this.totalQTY)
			// this.totalQTY > 0 ? this.atc_btn.disabled = false : this.atc_btn.disabled = true; 
          this.totalQTY > 0 && this.totalPrice > 2500 ? this.atc_btn.disabled = false : this.atc_btn.disabled = true; 
          
		} 
	}




}
customElements.define('extras-manager', ExtrasManager)



class MultipleItemsATC extends HTMLElement {

    constructor() {
      	super();
      	this.atcBtn = this.querySelector('button');
		this.status_el = this.querySelector('.status');
      	this.addListener()
    }

    addListener() {
		this.atcBtn.addEventListener('click', (e)=> {
			e.preventDefault();
			this.notification_status('loading');
			let prd_array, add_items;

			(async () => { 
				prd_array = await this.getProductsArray();
				prd_array.length > 0 ? add_items = await this.cart_addItems(prd_array) : null;
			
				console.log(add_items)
				add_items.status == 200 ? this.notification_status('success') : this.notification_status('failure')
			})();
		})
    }

	notification_status(status){
		if(this.status_el){

			this.status_el.innerHTML = ``;
			let status_html;

			if(status == 'loading'){
				status_html = `					
					<div class="[ mrg-t15 sm-mrg-0 ]" style="width: 30px; height: 30px;">
						<svg width="100%" height="100%" viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" fill="#000">
							<circle cx="15" cy="15" r="15">
								<animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite" />
								<animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />
							</circle>
							<circle cx="60" cy="15" r="9" fill-opacity="0.3">
								<animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite" />
								<animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite" />
							</circle>
							<circle cx="105" cy="15" r="15">
								<animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite" />
								<animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />
							</circle>
						</svg>
					</div>																		
				`;
			}

			if(status == 'success'){
				location.href = `/cart`

				status_html = `					
					<div class="[ mrg-t15 sm-mrg-0 ]" style="width: 30px; height: 30px;">
						<svg class="icon icon-checkmark aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="#549369"/>
						</svg>
					</div>					
				`;
			}

			if(status == 'failure'){
				this.atcBtn.disabled = true;
				status_html = `				
					<div class="[ mrg-t15 sm-mrg-0 ]" style="width: 30px; height: 30px; flex-shrink: 0;">
						<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
							<circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
							<circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
							<path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
							<path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
						</svg>
					</div>

					
					<span class="failure txt-14">Παρουσιάστηκε κάποιο πρόβλήμα. Παρακαλώ δοκιμάστε αργότερα</span>			
				`;
			}

			this.status_el.innerHTML = `${status_html}`;

		}
		
	}

    async getProductsArray() {
      	let items = document.querySelectorAll('extras-manager product-card');
		if(items){
			let a = [];
			items.forEach((item) => {      
				if( Number(item.dataset.item_totalqty) > 0 ) {       
					let temp = {id:Number(item.dataset.item_id), quantity: Number(item.dataset.item_totalqty)}
					a.push(temp);
				} 
			})	
			return a;  		
		} 		
    }

    async cart_addItems(a) { 	  
		const data = {items: a};
		//console.log(data)
		const result = await fetch("/cart/add.json", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},        
			body: JSON.stringify(data)        
		});
		//console.log(result)		
		return result; 
    }

  }
  customElements.define('multiitem-atc', MultipleItemsATC)